/**
 * Action types for system Alarm Configation functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle user authentication.
 */

export const GET_SYSTEM_CONFIG = 'GET_SYSTEM_CONFIG';
export const GET_SYSTEM_CONFIG_SUCCESS = 'GET_SYSTEM_CONFIG_SUCCESS';
export const GET_SYSTEM_CONFIG_FAIL = 'GET_SYSTEM_CONFIG_FAIL';
export const EDIT_SYSTEM_CONFIG = 'EDIT_SYSTEM_CONFIG'
export const EDIT_SYSTEM_CONFIG_COMPLETE =  'EDIT_SYSTEM_CONFIG_COMPLETE';